export default "__VITE_ASSET__zl_$gr_6__"